import 'iframe-resizer/js/iframeResizer.contentWindow';
import { createRoot } from 'react-dom/client';
import { Provider } from 'react-redux';
import { RouterProvider } from 'react-router';
import { worker } from '../test/mocks/lib/serviceMock';
import './common/palette.scss';
import { main } from './configuration';
import { config } from './configuration/config';
import './configuration/setup/datadog';
import { handleLoginRedirect } from './configuration/setup/redirect';
import { store } from './configuration/setup/store';
import { router } from './routes/Router';

if (import.meta.env.VITE_E2E === 'true') {
    import('./configuration/setup/e2eTestSupport');
}

const renderApplication = () => {
    createRoot(document.getElementById('root') as HTMLElement).render(
        <Provider store={store}>
            <RouterProvider router={router} />
        </Provider>
    );
};

if (window.location.href.startsWith(config.login.redirectUri as string)) {
    handleLoginRedirect();
} else if (config.enableMockServer) {
    worker
        .start({
            onUnhandledRequest: 'bypass',
        })
        .then(() => main(renderApplication));
} else {
    main(renderApplication);
}
